
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course/[slug]/[courseUID]",
      function () {
        return require("private-next-pages/course/[slug]/[courseUID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/course/[slug]/[courseUID]"])
      });
    }
  